import React, { useState } from "react";
import { Form, Offcanvas, Spinner, Table } from "react-bootstrap";

const TableProperties = ({
  Show,
  Hide,
  Title,
  tableRef,
  onMouseDown,
  columnList,
  tableColumns,
  setTableColumns,
}) => {
  const handleCheckboxChange = (checked, column) => {
    setTableColumns((prev) => {
      const updated = { ...prev };
      if (checked) {
        updated[column.name] = true;
      } else {
        delete updated[column.name];
      }
      return updated;
    });
  };

  const handleSelectAllChange = (checked) => {
    if (checked) {
      const newSelected = {};
      columnList.forEach((col) => {
        newSelected[col.name] = true;
      });
      setTableColumns(newSelected);
    } else {
      setTableColumns({});
    }
  };

  const isChecked = (name) => !tableColumns[name];
  const allSelected =
    columnList?.length > 0 &&
    columnList?.every((col) => !tableColumns[col.name]);

  const [searchTerm, setSearchTerm] = useState("");

  const filteredColumns = columnList?.filter((item) => {
    const term = searchTerm.toLowerCase();
    return (
      item?.label?.toLowerCase().includes(term) ||
      item?.name?.toLowerCase().includes(term) ||
      item?.type?.toLowerCase().includes(term) ||
      String(item?.length || "").toLowerCase().includes(term)
    );
  });

  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          <Form.Control
            type="text"
            placeholder="Search by Label, Name, Type, or Length"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <Table ref={tableRef} className="m-0 custom-table" hover striped>
            <thead className="position-sticky top-0">
              <tr>
                <th
                  onMouseDown={(e) => onMouseDown(e, 0)}
                  style={{ width: 45 }}
                  className="text-center"
                >
                  <Form.Check
                    type="checkbox"
                    checked={allSelected}
                    onChange={(e) =>
                      handleSelectAllChange(allSelected ? true : false)
                    }
                  />
                </th>
                <th onMouseDown={(e) => onMouseDown(e, 1)}>Column Label</th>
                <th onMouseDown={(e) => onMouseDown(e, 2)}>Column Name</th>
                <th onMouseDown={(e) => onMouseDown(e, 3)}>Type</th>
                <th onMouseDown={(e) => onMouseDown(e, 4)}>Length</th>
              </tr>
            </thead>
            <tbody>
              {filteredColumns?.map((item, index) => (
                <tr key={`dynamic-${index}`}>
                  <td className="text-center">
                    <Form.Check
                      type="checkbox"
                      checked={isChecked(item.name)}
                      onChange={(e) =>
                        handleCheckboxChange(
                          isChecked(item.name) ? true : false,
                          item
                        )
                      }
                    />
                  </td>
                  <td>{item?.label}</td>
                  <td>{item?.name}</td>
                  <td className="text-capitalize">{item?.type}</td>
                  <td>{item?.length}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default TableProperties;
